/* help.js — Contenu du GUIDE D'UTILISATION (FAQ) par rôle, trilingue FR / Darija / EN.
   Affiché via l'icône « ? » de l'en-tête et automatiquement à la fin de l'activation.
   Chaque item : { icon: <nom lucide>, text: <phrase courte> }. */

export const HELP = {
  fr: {
    chrome: {
      title: "Guide d'utilisation",
      subtitle: "Ce que vous pouvez faire ici",
      your_role: "Votre rôle",
      canDo: "Ce que vous pouvez faire",
      everyone: "Pour tout le monde",
      gotit: "J'ai compris",
    },
    roles: {
      president: {
        tagline: "Vous pilotez la copropriété et garantissez la transparence.",
        items: [
          { icon: "UserPlus", text: "Créez les comptes des résidents et envoyez l'invitation par WhatsApp." },
          { icon: "KeyRound", text: "Réinitialisez un code PIN oublié et régénérez les codes d'invitation." },
          { icon: "ShieldCheck", text: "Changez les rôles (nommer un trésorier demande une double validation « 4 yeux »)." },
          { icon: "CheckCircle2", text: "Validez les demandes d'alimentation de la caisse (retrait banque → espèces)." },
          { icon: "AlertTriangle", text: "Traitez et résolvez les anomalies de rapprochement bancaire." },
          { icon: "ScanLine", text: "Déposez factures, relevés et documents : le Dépôt intelligent (IA) range tout au bon endroit." },
          { icon: "FileDown", text: "Générez et partagez les rapports trimestriels (PDF / WhatsApp)." },
          { icon: "ClipboardList", text: "Consultez le journal d'audit de toutes les actions sensibles." },
        ],
      },
      tresorier: {
        tagline: "Vous gérez l'argent au quotidien, sous le contrôle du président.",
        items: [
          { icon: "HandCoins", text: "Demandez une alimentation de caisse avec justificatif (validée par le président)." },
          { icon: "Landmark", text: "Importez les relevés bancaires : l'IA fait le rapprochement automatiquement." },
          { icon: "ScanLine", text: "Enregistrez les dépenses (avec facture, ou « sans facture » en déclarant l'artisan)." },
          { icon: "ShieldCheck", text: "Validez les changements de rôle qui vous concernent (4 yeux)." },
          { icon: "FileDown", text: "Téléchargez les documents et les rapports financiers." },
        ],
      },
      conseil: {
        tagline: "Vous accompagnez le bureau et veillez à la bonne gestion.",
        items: [
          { icon: "FolderPlus", text: "Ajoutez, modifiez ou classez les documents officiels." },
          { icon: "ClipboardList", text: "Consultez le journal d'audit (accès réservé au bureau)." },
          { icon: "Eye", text: "Accédez à toutes les informations financières en toute transparence." },
        ],
      },
      coproprietaire: {
        tagline: "Vous suivez la vie de l'immeuble en toute transparence.",
        items: [
          { icon: "HelpCircle", text: "Posez une question sur n'importe quelle dépense." },
          { icon: "TriangleAlert", text: "Signalez un problème (fuite, ascenseur, propreté…) et suivez son avancement." },
          { icon: "Star", text: "Recommandez un artisan et notez ceux des voisins." },
          { icon: "Eye", text: "Consultez toutes les dépenses, revenus et rapports financiers." },
        ],
      },
      gardien: {
        tagline: "Vous êtes le relais du quotidien dans l'immeuble.",
        items: [
          { icon: "Wrench", text: "Suivez et mettez à jour les incidents qui vous sont assignés." },
          { icon: "TriangleAlert", text: "Signalez un problème constaté dans les parties communes." },
          { icon: "Bell", text: "Restez informé des annonces (coupures, AG, consignes)." },
          { icon: "Phone", text: "Retrouvez rapidement les contacts d'urgence." },
        ],
      },
    },
    common: [
      { icon: "Wallet", text: "Suivez les finances en temps réel : dépenses, revenus, soldes banque et caisse, réserve." },
      { icon: "FileText", text: "Consultez les documents officiels (règlement, contrats, PV)." },
      { icon: "Users", text: "Parcourez l'annuaire des résidents ; demandez les coordonnées (la personne autorise)." },
      { icon: "Contact", text: "Trouvez un artisan recommandé et appelez-le ou contactez-le par WhatsApp." },
      { icon: "BellRing", text: "Activez les notifications push pour être alerté (page « Plus »)." },
      { icon: "Languages", text: "Changez la langue (Français / الدارجة / English) et le mode sombre." },
    ],
  },

  ar: {
    chrome: {
      title: "دليل الاستعمال",
      subtitle: "أشنو تقدر دير هنا",
      your_role: "الدور ديالك",
      canDo: "أشنو تقدر دير",
      everyone: "للجميع",
      gotit: "فهمت",
    },
    roles: {
      president: {
        tagline: "نتا كتسيّر الإقامة وكتضمن الشفافية.",
        items: [
          { icon: "UserPlus", text: "زيد حسابات السكان وصيفط الدعوة عبر واتساب." },
          { icon: "KeyRound", text: "عاود ضبط رمز PIN المنسي وجدّد أكواد الدعوة." },
          { icon: "ShieldCheck", text: "بدّل الأدوار (تعيين أمين المال خاصو مصادقة مزدوجة « 4 عينين »)." },
          { icon: "CheckCircle2", text: "صادق على طلبات تمويل الصندوق (سحب من البنك ← كاش)." },
          { icon: "AlertTriangle", text: "عالج وحلّ اختلالات المطابقة البنكية." },
          { icon: "ScanLine", text: "ودّع الفواتير والكشوفات والوثائق : الإيداع الذكي كيرتّب كلشي فبلاصتو." },
          { icon: "FileDown", text: "ولّد وشارك التقارير الفصلية (PDF / واتساب)." },
          { icon: "ClipboardList", text: "شوف سجل التدقيق ديال جميع العمليات الحساسة." },
        ],
      },
      tresorier: {
        tagline: "نتا كتدبّر الفلوس نهارياً، تحت مراقبة الرئيس.",
        items: [
          { icon: "HandCoins", text: "اطلب تمويل الصندوق مع وثيقة إثبات (كيصادق عليه الرئيس)." },
          { icon: "Landmark", text: "استورد الكشوفات البنكية: الذكاء الاصطناعي كيدير المطابقة أوتوماتيكياً." },
          { icon: "ScanLine", text: "سجّل المصاريف (بفاتورة، ولا « بلا فاتورة » مع التصريح بالصانع)." },
          { icon: "ShieldCheck", text: "صادق على تغييرات الأدوار اللي كتعنيك (4 عينين)." },
          { icon: "FileDown", text: "حمّل الوثائق والتقارير المالية." },
        ],
      },
      conseil: {
        tagline: "نتا كتعاون المكتب وكتسهر على حسن التسيير.",
        items: [
          { icon: "FolderPlus", text: "زيد، عدّل ولا رتّب الوثائق الرسمية." },
          { icon: "ClipboardList", text: "شوف سجل التدقيق (خاص بالمكتب)." },
          { icon: "Eye", text: "دخل لجميع المعلومات المالية بكل شفافية." },
        ],
      },
      coproprietaire: {
        tagline: "نتا كتّبع حياة العمارة بكل شفافية.",
        items: [
          { icon: "HelpCircle", text: "طرح سؤال على أي مصروف." },
          { icon: "TriangleAlert", text: "بلّغ على مشكل (تسربة، أصنصور، نظافة…) وتبّع التقدّم." },
          { icon: "Star", text: "نصح بصانع ونقّط اللي نصحو بيهم الجيران." },
          { icon: "Eye", text: "شوف جميع المصاريف والمداخيل والتقارير المالية." },
        ],
      },
      gardien: {
        tagline: "نتا الوسيط ديال اليومي فالعمارة.",
        items: [
          { icon: "Wrench", text: "تبّع وحدّث الأعطاب اللي مسندة ليك." },
          { icon: "TriangleAlert", text: "بلّغ على مشكل لقيتيه فالأجزاء المشتركة." },
          { icon: "Bell", text: "بقا مطّلع على الإعلانات (قطع الماء، الجمع العام، التعليمات)." },
          { icon: "Phone", text: "لقا بسرعة أرقام الطوارئ." },
        ],
      },
    },
    common: [
      { icon: "Wallet", text: "تبّع المالية فالوقت الحقيقي: المصاريف، المداخيل، أرصدة البنك والصندوق، الاحتياطي." },
      { icon: "FileText", text: "شوف الوثائق الرسمية (النظام الداخلي، العقود، المحاضر)." },
      { icon: "Users", text: "تصفّح دليل السكان؛ اطلب معلومات الاتصال (الشخص كيوافق)." },
      { icon: "Contact", text: "لقا صانع منصوح بيه واتصل بيه ولا عبر واتساب." },
      { icon: "BellRing", text: "فعّل الإشعارات باش توصلك التنبيهات (صفحة « المزيد »)." },
      { icon: "Languages", text: "بدّل اللغة (Français / الدارجة / English) والوضع الليلي." },
    ],
  },

  en: {
    chrome: {
      title: "User guide",
      subtitle: "What you can do here",
      your_role: "Your role",
      canDo: "What you can do",
      everyone: "For everyone",
      gotit: "Got it",
    },
    roles: {
      president: {
        tagline: "You run the building and guarantee transparency.",
        items: [
          { icon: "UserPlus", text: "Create resident accounts and send the invitation via WhatsApp." },
          { icon: "KeyRound", text: "Reset a forgotten PIN and regenerate invitation codes." },
          { icon: "ShieldCheck", text: "Change roles (appointing a treasurer needs a two-person “four-eyes” approval)." },
          { icon: "CheckCircle2", text: "Approve cash top-up requests (bank withdrawal → cash box)." },
          { icon: "AlertTriangle", text: "Review and resolve bank reconciliation anomalies." },
          { icon: "ScanLine", text: "Drop invoices, statements and documents: the AI smart drop files everything in the right place." },
          { icon: "FileDown", text: "Generate and share quarterly reports (PDF / WhatsApp)." },
          { icon: "ClipboardList", text: "Review the audit log of every sensitive action." },
        ],
      },
      tresorier: {
        tagline: "You handle the money day to day, under the president's oversight.",
        items: [
          { icon: "HandCoins", text: "Request a cash top-up with proof (approved by the president)." },
          { icon: "Landmark", text: "Import bank statements: the AI reconciles them automatically." },
          { icon: "ScanLine", text: "Record expenses (with an invoice, or “no invoice” by declaring the worker)." },
          { icon: "ShieldCheck", text: "Approve role changes that concern you (four-eyes)." },
          { icon: "FileDown", text: "Download documents and financial reports." },
        ],
      },
      conseil: {
        tagline: "You support the board and watch over good management.",
        items: [
          { icon: "FolderPlus", text: "Add, edit or organise official documents." },
          { icon: "ClipboardList", text: "Review the audit log (board access only)." },
          { icon: "Eye", text: "Access all financial information in full transparency." },
        ],
      },
      coproprietaire: {
        tagline: "You follow the building's life in full transparency.",
        items: [
          { icon: "HelpCircle", text: "Ask a question about any expense." },
          { icon: "TriangleAlert", text: "Report a problem (leak, lift, cleanliness…) and track its progress." },
          { icon: "Star", text: "Recommend a tradesperson and rate the ones your neighbours suggested." },
          { icon: "Eye", text: "See all expenses, income and financial reports." },
        ],
      },
      gardien: {
        tagline: "You are the day-to-day link inside the building.",
        items: [
          { icon: "Wrench", text: "Follow up and update the incidents assigned to you." },
          { icon: "TriangleAlert", text: "Report a problem you notice in the common areas." },
          { icon: "Bell", text: "Stay informed of announcements (water cuts, AGM, instructions)." },
          { icon: "Phone", text: "Quickly find the emergency contacts." },
        ],
      },
    },
    common: [
      { icon: "Wallet", text: "Track finances in real time: expenses, income, bank & cash balances, reserve." },
      { icon: "FileText", text: "Consult the official documents (bylaws, contracts, minutes)." },
      { icon: "Users", text: "Browse the resident directory; request contact details (the person approves)." },
      { icon: "Contact", text: "Find a recommended tradesperson and call or WhatsApp them." },
      { icon: "BellRing", text: "Enable push notifications to get alerts (in the “More” page)." },
      { icon: "Languages", text: "Change the language (Français / الدارجة / English) and dark mode." },
    ],
  },
};
